export default "__VITE_ASSET__Bdf4Z6MG__"